var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"absolute top-0 left-0 right-0 w-full h-[320px] overflow-hidden"},[_c('div',{staticClass:"merchant-bg",attrs:{"aria-label":_vm.name,"role":"text"}},[(_vm.img)?_c(_setup.ImageLoader,{staticClass:"merchant-img",attrs:{"src":_vm.img,"aria-hidden":"true"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }